module.exports = __webpack_public_path__ + "img/com.moji.mjweather.alpha7.c6d84702.png";